export default "__VITE_ASSET__C$ZQwtF8__"